import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/landing/StatsSection";
import CommunitySection from "@/components/landing/CommunitySection";
import LearningPathSection from "@/components/landing/LearningPathSection";
import JourneyStrip from "@/components/landing/JourneyStrip";
import ResourcesFaqSection from "@/components/landing/ResourcesFaqSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import EcosystemSection from "@/components/landing/EcosystemSection";
import LandingTerminal from "@/pages/LandingTerminal";

/* Landing page — Figma "Project GenRYZ" Frame 130 (node 102:2924). */

export default function LandingPage() {
  const [skillPaths, setSkillPaths] = useState([]);

  // Design preview: ?theme=aurora|bubblegum|sunset recolors the legacy palette vars.
  const [sp] = useSearchParams();
  const theme = sp.get("theme");
  useEffect(() => {
    const t = ["aurora", "bubblegum", "sunset"].includes(theme) ? theme : "aurora";
    document.body.dataset.theme = t;
    return () => { document.body.dataset.theme = "aurora"; };
  }, [theme]);

  useEffect(() => {
    api.get("/skill-paths").then(r => setSkillPaths(r.data || [])).catch(() => {});
  }, []);

  // "/#anchor" links are handled by ScrollToTop in App.js, for every route and
  // for same-route hash changes alike.

  // Specialty design preview: a fully restyled terminal aesthetic.
  if (theme === "terminal") return <LandingTerminal />;

  return (
    <div className="min-h-screen overflow-x-hidden bg-white text-black">
      <SiteHeader />

      <HeroSection />

      <StatsSection />

      <CommunitySection />

      <LearningPathSection paths={skillPaths} />

      <JourneyStrip />

      <ResourcesFaqSection />

      <TestimonialsSection />

      <EcosystemSection />

      <SiteFooter />
    </div>
  );
}
